import script from "./FlashAlertApp.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashAlertApp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__